<div class="background">

  <div class="card">
  </div>
  <h4 class="header">Notifications</h4>
  <section>
    <div class="example-button-row">
      <button mat-button class="buttonchange" (click)="showUpcommingNotifications()"
        [ngClass]="activeClass == 'UpComing' ? 'active' : 'noactive'">UPCOMING</button>
      <button mat-button class="buttonchange" [ngClass]="activeClass == 'Past' ? 'active' : 'noactive'"
        (click)="showPastNotifications()">PAST</button>
      <button class="buttoncreate" (click)="createNotification()">+ Create New Notification</button>
    </div>
  </section>
  <div class="headerarrow arrowheader">
    <span class="filtercolor">Filter by<img src="assets/images/Sort-table.png" class="sortimage"
        alt="up arrow" /></span>
  </div>
  <div class="work-orders-content clearfix" *ngIf="tabVal === 'UpComing'">
    <table #dataTable class="rail-table table-responsive" id="wo-table">
      <thead>
        <tr class="row-head">
          <th class="tablehead">SUMMARY
            <span class="sorting-both">
              <img src="assets/images/Sort-table.png" class="arrowone" alt="up arrow" />
            </span>
          </th>
          <th>ISSUED
            <span class="sorting-both">
              <img src="assets/images/Sort-table.png" class="arrow" alt="up arrow" />
            </span> <br>DATE
          </th>
          <th>ISSUED
            <span class="sorting-both">
              <img src="assets/images/Sort-table.png" class="arrow" alt="up arrow" />
            </span><br>TIME
          </th>
          <th>
            ISSUED
            <span class="sorting-both">
              <img src="assets/images/Sort-table.png" class="arrow" alt="up arrow" />
            </span><br> BY
          </th>
          <th>
            PUBLISHING
            <span class="sorting-both">
              <img src="assets/images/Sort-table.png" class="arrow" alt="up arrow" />
            </span><br>DATE
          </th>
          <th>
            PUBLISHING
            <span class="sorting-both">
              <img src="assets/images/Sort-table.png" class="arrow" alt="up arrow" />
            </span><br>TIME
          </th>
          <th *ngIf="upCommingNotifiationsActive" class='action'>
            ACTION
            <span class="sorting-both">
              <img src="assets/images/Sort-table.png" class="arrowone" alt="up arrow" />
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of displayNotifications; let i = index">
          <td class="columnWidth"><span class="columncol navigation">{{item.summary}}</span></td>

          <td class="status">
            <span>
              <span class="columncol">{{item.issueDateTime | dateFormat :'dd/MM/yyyy' }}</span>
            </span>
          </td>
          <td>
            <span class="columncol">{{item.issueDateTime | dateFormat:'HH:mm' }}</span>
          </td>
          <td>
            <span class="columncol">{{item.modifiedName }}</span>
          </td>
          <td>
            <span class="columncol">{{item.publishDateTime | dateFormat:'dd/MM/yyyy' }}</span>
          </td>
          <td>
            <span class="columncol">{{item.publishDateTime | dateFormat:'HH:mm' }}</span>
          </td>

          <td *ngIf="upCommingNotifiationsActive" disabled="true"
            [ngClass]="{'disabled': userObject.id != item.modifiedBy}">
            <div class="buttonclass" (click)="modifyNotification(item)">
              <span>EDIT</span>
            </div>
            <div class="buttonapprovedclass" (click)="deleteNotification(item)">
              <span>DELETE</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
